import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/tetris-logs'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getLink: NoParamEndpointConstructor
  download: NoParamEndpointConstructor
}

export const tetrisLogsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  getLink: () => `${baseUrl}/link`,
  download: () => `${baseUrl}/download`,
}
